import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoints } from "../../../helper/endpoints";
import { axiosBaseQuery } from "../axiosBaseQuery";

interface PolicyWording {
	productId: number;
	productName: string;
	policyWordingId: number;
	policyWordingName: string;
	policyWordingUrl: string;
}

interface PolicyWordingResponse {
    [policyId: number]: PolicyWording[];
}

// Define a service using a base URL and expected endpoints
export const documentsApi = createApi({
	reducerPath: "documentsApi",
	baseQuery: axiosBaseQuery({ baseUrl: "" }),
    tagTypes: ["POLICY_WORDING"],
	endpoints: (builder) => ({
		getPolicyWordings: builder.query<PolicyWording[], number>({
            providesTags: (result, error, policyId) => [{ type: "POLICY_WORDING", id: policyId }],
			query: (policyId) => ({
				url: `${endpoints.GET_WORDING_BY_QUOTE_ID ?? ""}?policyId=${policyId}`,
				method: "GET",
				// data: policyId,
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json, text/plain, */*",
				},
			}),
			transformErrorResponse: (response) => {
				console.log("ERROR RESPONSE getPolicyWordings", response);
				return response;
			},
			transformResponse: (response) => {
				// console.log("getPolicyWordings", response);
				return response;
			},
		}),
        getPolicyWordingsByPolicyIdList: builder.query<PolicyWordingResponse, number[]>({
            providesTags: (result, error, policyIds) => policyIds.map(id => ({ type: "POLICY_WORDING", id })),
            queryFn: async (policyIds, _queryApi, _extraOptions, baseQuery) => {
				let policies = policyIds.reduce((acc, val) => {
                    acc = {
                        ...acc,
                        [val]: {},
                    };
                    return acc;
                }, {});
                for (const policyId of policyIds) {
                    const result = await baseQuery({
                        url: `${endpoints.GET_POLICY_WORDING ?? ""}?policyId=${policyId}`,
                        method: "GET",
                        // data: policyId,
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json, text/plain, */*",
                        },
                    });
    
                    if (result.error) {
                        // console.log(`Error updating quote group ${quote.id} in queryFn`, result.error);
                        return {
                            error: result.error,
                        };
                    }
                    policies = {
                        ...policies,
                        [policyId]: result.data,
                    }
                }
              
                return {
                    data: policies,
                };
				
			},
		}),
		getWordingsByQuoteIdList: builder.query<PolicyWordingResponse, number[]>({
            providesTags: (result, error, quoteIds) => quoteIds.map(id => ({ type: "POLICY_WORDING", id })),
            queryFn: async (quoteIds, _queryApi, _extraOptions, baseQuery) => {
				let quotes = quoteIds.reduce((acc, val) => {
                    acc = {
                        ...acc,
                        [val]: {},
                    };
                    return acc;
                }, {});
                for (const quoteId of quoteIds) {
                    const result = await baseQuery({
                        url: `${endpoints.GET_WORDING_BY_QUOTE_ID ?? ""}?quoteId=${quoteId}`,
                        method: "GET",
                        // data: quoteId,
                        headers: {
                            "Content-Type": "application/json",
                            Accept: "application/json, text/plain, */*",
                        },
                    });
    
                    if (result.error) {
                        // console.log(`Error updating quote group ${quote.id} in queryFn`, result.error);
                        return {
                            error: result.error,
                        };
                    }
                    quotes = {
                        ...quotes,
                        [quoteId]: result.data,
                    }
                }
              
                return {
                    data: quotes,
                };
				
			},
		}),
	}),
});

// Export hooks for usage in functional components
export const {
	useGetPolicyWordingsQuery,
    useGetPolicyWordingsByPolicyIdListQuery,
    useGetWordingsByQuoteIdListQuery,
} = documentsApi;